
/**
 * ClearableInput
 *
 * Props:
 * - value: string // current input value
 * - onChange: (value) => void // callback when input changes
 * - onClear?: () => void // callback when clear button is clicked
 * - placeholder?: string // placeholder text
 * - className?: string // additional CSS classes for the input
 * - type?: string // input type (default: "text")
 * - disabled?: boolean // whether input is disabled
 * - ...props // any other input props
 */
export default function ClearableInput({
  value,
  onChange,
  onClear,
  placeholder = "",
  className = "",
  type = "text",
  disabled = false,
  ...props
}) {
  const hasValue = value && value.trim() !== '';

  const handleClear = () => {
    onClear?.();
  };

  const handleInputChange = (e) => {
    onChange?.(e.target.value);
  };

  return (
    <div className="relative">
      <input
        type={type}
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${className}`}
        {...props}
      />
      {/* Clear button - same style as dropdown */}
      {hasValue && !disabled && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
          title="Clear input"
        >
          <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}